import React from 'react';
import { observer } from 'mobx-react';
import classnames from 'classnames';

import { DateType } from 'shared/types';
import { useMedia, useObservable } from 'shared/hooks';

import { CalendarPageDayPreview } from 'pages/calendar/components/CalendarPageDayPreview';
import { Store } from 'pages/calendar/store';

import './styles.scss';

type PropsType = {
    date: DateType;
    className: string;
    isOuter: boolean;
};

export const CalendarPageYearMonthDay = observer(function CalendarPageYearMonthDay({ date, className, isOuter }: PropsType) {
    const store = useObservable({
        bounds: null as null | DOMRect,
        isOpened: false,
    });

    const { isDesktop } = useMedia();

    return (
        <>
            <div
                key={date.format()}
                className={classnames(className, {
                    'ui-new-calendar-control__day--selected': store.isOpened,
                })}
                onClick={e => {
                    if (!isDesktop) {
                        Store.update({
                            date,
                            view: 'day',
                        });
                        return;
                    }
                    if (store.isOpened) {
                        store.set('isOpened', false);
                        return;
                    }
                    store.set('bounds', e.currentTarget.getBoundingClientRect());
                    setTimeout(() => {
                        store.set('isOpened', true);
                    }, 100);
                }}
            >
                {date.format('D')}
            </div>
            <CalendarPageDayPreview
                key={date.format() + '~'}
                isOpened={store.isOpened}
                onClose={() => {
                    console.log(123);
                    store.set('isOpened', false);
                }}
                date={date}
                bounds={store.bounds}
            />
        </>
    );
});
